<template>
    <div class="home">
        <Header />
        <div class="container" v-if="workspaces_loaded">
            <template v-if="!isEmptyList(invitations)">
                <div class="workspaces-header">
                    <h4 style="float: left">Invitations</h4>
                </div>
                <div class="workspace" v-for="invitation in invitations" :key="invitation.id" style="cursor: default;">
                    <div class="col-sm-7">
                        <span class="name">{{invitation.workspace.name}}</span>
                    </div>
                    <div class="col-sm-3" style="text-align: center; padding-right: 0px;">
                        <b-button type="is-success" v-if="!invitation_accepting" @click="_acceptInvitation(invitation.id)">Accept invitation</b-button>
                        <b-button type="is-success" v-else loading>Accept invitation</b-button>
                    </div>
                    <div class="col-sm-2" style="text-align: center; padding-right: 0px; padding-left: 5px;">
                        <b-button type="is-danger" v-if="!invitation_accepting" @click="_dismissInvitation(invitation.id)">Dismiss</b-button>
                        <b-button type="is-danger" v-else loading>Dismiss</b-button>
                    </div>
                </div>
            </template>
            <template v-if="!isEmptyList(workspaces)">
                <div class="workspaces-header">
                    <h4 style="float: left">Workspaces</h4>
                    <b-button type="is-default" @click="goToCreateNewWorkspace()" style="float: right">New workspace</b-button>
                </div>
                <div class="workspace" v-for="workspace in workspaces" :key="workspace.id" @click="goToSingleWorkspace(workspace.id)">
                    <div class="col-sm-8">
                        <span class="name">{{workspace.name}}</span>
                    </div>
                    <div class="col-sm-2">
                        <b-tooltip label="Bugs">
                            <span class="bugs"><i class="fas fa-bug"></i> {{workspace.tasks}}</span>
                        </b-tooltip>
                    </div>
                    <div class="col-sm-2">
                        <b-tooltip label="Members">
                            <span class="members"><i class="fas fa-users"></i> {{workspace.members.length + 1}}</span>
                        </b-tooltip>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="empty-workspaces">
                    <p>You don't have any Workspaces</p>
                    <b-button type="is-primary" @click="goToCreateNewWorkspace()">Create workspace</b-button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import jwt_decode from 'jwt-decode'
import {getJWT, getHeaders, isEmptyList} from '../logic/global'
import {getWorkspaces} from '../logic/workspace'
import {getUserInvitations, acceptUserInvitation, dismissUserInvitation} from '../logic/account'
import Header from '../components/Header'


let workspaces = []
let workspaces_loaded = false;
let invitations = []
let invitations_loaded = false;
let invitation_accepting = false;

export default {
    name: 'Workspaces',
    components: {Header},
    computed: mapGetters(["getWorkspaceId"]),
    data() {
        return {
            workspaces: workspaces,
            workspaces_loaded: workspaces_loaded,
            invitations: invitations,
            invitations_loaded: invitations_loaded,
            invitation_accepting: invitation_accepting,
        }
    },
    methods: {
        isEmptyList: isEmptyList,
        goToSingleWorkspace: function(workspace_id){
            this.$router.push({name: 'workspace_single', params: {workspace_id: workspace_id}})
        },
        goToCreateNewWorkspace: function(){
            this.$router.push({name: 'workspace_create'});
        },
        _getWorkspaces: function(){
            getWorkspaces().then(response => {
                this.workspaces = response.data.results;
                this.workspaces_loaded = true;
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        },
        _acceptInvitation: function(invitation_id){
            this.invitation_accepting = true;
            let token = jwt_decode(getJWT());
            acceptUserInvitation(token["id"], invitation_id).then(response => {
                this.invitation_accepting = true;
                this._getWorkspacesInvitations()
                this._getWorkspaces()
            }).catch(error => {
                this.showSuccessMsg("Something went wrong. Try again later or contact support.", "is-danger")
            })
        },
        _dismissInvitation: function(invitation_id){
            this.invitation_accepting = true;
            let token = jwt_decode(getJWT());
            dismissUserInvitation(token["id"], invitation_id).then(response => {
                this.invitation_accepting = true;
                this._getWorkspacesInvitations()
            })
        },
        _getWorkspacesInvitations: function(){
            let token = jwt_decode(getJWT());
            getUserInvitations(token["id"]).then(response => {
                this.invitations = response.data;
                this.invitations_loaded = true;
            })
        },
        showSuccessMsg: function(message, msg_type){
            this.$toast.open({message: message, type: msg_type})
        },
    },
    mounted: function(){
       this._getWorkspaces()
       this._getWorkspacesInvitations()
    }
}
</script>

<style scoped>
    .empty-workspaces{
        background: #fff;
        padding: 40px;
        text-align: center;
        margin-top: 70px;
    }
    .workspaces-header{
        overflow: hidden;
        margin-top: 50px;
        margin-bottom: 25px;
        border-bottom: 1px solid #d0d0d0;
        padding-bottom: 15px;
    }
    .workspaces-header h4{
        margin-top: 10px;
        margin-bottom: 0px;
        font-size: 16px !important;
    }
    .workspaces-header >>> .button{
        font-size: 15px;
    }
    .workspace{
        padding: 35px;
        background: #fff;
        margin-bottom: 50px;
        overflow: hidden;
        cursor: pointer;
    }
    .workspace .name{
        font-size: 19px;
        line-height: 32px;
        font-weight: 200;
    }
    .workspace .members{
        font-size: 22px;
    }
    .workspace .bugs{
        font-size: 22px;
    }
    .workspace >>> .b-tooltip.is-primary:after {
        font-size: 12px;
        padding: 3px 10px;
    }
</style>
